<template>
	<tr>
		<td class="dense" :class="{'tdGreen': checkClasses['filter_id']}">{{ item.id }}</td>
		<td :class="{'tdGreen': checkClasses['filter_unit_type']}">{{ item['unit_type'] }}</td>
		<td :class="{'tdGreen': checkClasses['filter_unit']}">{{ item.unit }}</td>
		<td class="center dense" :class="{'tdGreen': checkClasses['filter_arrived']}">
			<svg-sprite v-if="item.arrived" height="16" width="17" icon-id="done"></svg-sprite>
		</td>
		<td :class="{'tdGreen': checkClasses['filter_dispatch_request']}" align="center">
			<span @click="onCommentsPopup" class="descN">{{ item.dispatch_request }}</span>
		</td>
		<slot></slot>
	</tr>
</template>

<script>
import { formatCurrency } from "@/helper";

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	methods: {
		getIconColor(value) {
			const color = value ? '#19BC38' : '#8F90A6';
			return `color: ${ color }`;
		},
		onEdit() {
			this.$emit('updateEdit', this.item.id);
		},
		getTotal(total) {
			return formatCurrency(total);
		},
		onCommentsPopup() {
			const { id, unit, unit_type } = this.item;
			this.$emit('updateCommentsPopup', { id, unit, unit_type });
		}
	}
};
</script>

<style lang="scss" scoped>
@import "NewOrdersTableTR";
</style>

<style lang="scss">
@import "NewOrdersTableTRAll";
</style>
